import { trackInteraction } from ".";
import { interactionEventActions, interactionEventCategory, interactionEventLabels, interactionEventPages }
  from "./dispensation-home";

interface PrescriptionDetailEventPayload {
  prescriptionId: string | number;
  drugstoreId: number;
  chainId: number;
  drugstoreName: string;
  chainName: string;
  drugstoreUF: string | null;
}

type TrackClickValidatePrescriptionPayload = PrescriptionDetailEventPayload
type TrackClickDownloadFullPrescriptionPayload = PrescriptionDetailEventPayload
type TrackClickDownloadIndividualPrescriptionPayload = PrescriptionDetailEventPayload
type TrackClickCancelDispensationPayload = PrescriptionDetailEventPayload
type TrackClickDispensePayload = PrescriptionDetailEventPayload & {
  partiallyDispensedItens: number;
}
type TrackSelectQuantityPayload = PrescriptionDetailEventPayload & {
  itemId: string | number;
  quantity: string | number;
}
type TrackSelectItemPayload = PrescriptionDetailEventPayload & {
  itemId: string | number;
  canDispensePartial: boolean;
}

export function trackClickValidateSignature({
  prescriptionId,
  drugstoreId,
  chainId,
  drugstoreName,
  chainName,
  drugstoreUF,
}: TrackClickValidatePrescriptionPayload): void {
  trackInteraction({
    page: interactionEventPages.dispensador_detalhes_receita,
    category: interactionEventCategory,
    action: interactionEventActions.click,
    label: interactionEventLabels.validar_assinatura,
    properties: {
      prescription_id: String(prescriptionId),
      drugstore_id: drugstoreId,
      chain_id: chainId,
      drugstore_name: String(drugstoreName),
      chain_name: String(chainName),
      drugstore_uf: String(drugstoreUF),
    },
  });
}

export function trackClickDownloadFullPrescription({
  prescriptionId,
  drugstoreId,
  chainId,
  drugstoreName,
  chainName,
  drugstoreUF,
}: TrackClickDownloadFullPrescriptionPayload): void {
  trackInteraction({
    page: interactionEventPages.dispensador_detalhes_receita,
    category: interactionEventCategory,
    action: interactionEventActions.click,
    label: interactionEventLabels.baixar_prescricao_completa,
    properties: {
      prescription_id: String(prescriptionId),
      drugstore_id: drugstoreId,
      chain_id: chainId,
      drugstore_name: String(drugstoreName),
      chain_name: String(chainName),
      drugstore_uf: String(drugstoreUF),
    },
  });
}

export function trackClickDownloadIndividualPrescription({
  prescriptionId,
  drugstoreId,
  chainId,
  drugstoreName,
  chainName,
  drugstoreUF,
}: TrackClickDownloadIndividualPrescriptionPayload): void {
  trackInteraction({
    page: interactionEventPages.dispensador_detalhes_receita,
    category: interactionEventCategory,
    action: interactionEventActions.click,
    label: interactionEventLabels.baixar_prescricao_individual,
    properties: {
      prescription_id: String(prescriptionId),
      drugstore_id: drugstoreId,
      chain_id: chainId,
      drugstore_name: String(drugstoreName),
      chain_name: String(chainName),
      drugstore_uf: String(drugstoreUF),
    },
  });
}

export function trackClickCancelDispensation({
  prescriptionId,
  drugstoreId,
  chainId,
  drugstoreName,
  chainName,
  drugstoreUF,
}: TrackClickCancelDispensationPayload): void {
  trackInteraction({
    page: interactionEventPages.dispensador_detalhes_receita,
    category: interactionEventCategory,
    action: interactionEventActions.click,
    label: interactionEventLabels.cancelar_dispensacao,
    properties: {
      prescription_id: String(prescriptionId),
      drugstore_id: drugstoreId,
      chain_id: chainId,
      drugstore_name: String(drugstoreName),
      chain_name: String(chainName),
      drugstore_uf: String(drugstoreUF),
    },
  });
}

export function trackClickDispense({
  prescriptionId,
  drugstoreId,
  chainId,
  partiallyDispensedItens,
  drugstoreName,
  chainName,
  drugstoreUF,
}: TrackClickDispensePayload): void {
  trackInteraction({
    page: interactionEventPages.dispensador_detalhes_receita,
    category: interactionEventCategory,
    action: interactionEventActions.click,
    label: interactionEventLabels.dispensar,
    properties: {
      prescription_id: String(prescriptionId),
      drugstore_id: drugstoreId,
      chain_id: chainId,
      partially_dispensed_itens: String(partiallyDispensedItens),
      drugstore_name: String(drugstoreName),
      chain_name: String(chainName),
      drugstore_uf: String(drugstoreUF),
    },
  });
}

export function trackSelectQuantity({
  prescriptionId,
  itemId,
  quantity,
  drugstoreId,
  chainId,
  drugstoreName,
  chainName,
  drugstoreUF,
}: TrackSelectQuantityPayload): void {
  trackInteraction({
    page: interactionEventPages.dispensador_detalhes_receita,
    category: interactionEventCategory,
    action: interactionEventActions.select,
    label: interactionEventLabels.selecionar_quantidade,
    properties: {
      prescription_id: String(prescriptionId),
      item_id: String(itemId),
      quantity: String(quantity),
      drugstore_id: drugstoreId,
      chain_id: chainId,
      drugstore_name: String(drugstoreName),
      chain_name: String(chainName),
      drugstore_uf: String(drugstoreUF),
    },
  });
}

export function trackSelectItem({
  prescriptionId,
  itemId,
  canDispensePartial,
  drugstoreId,
  chainId,
  drugstoreName,
  chainName,
  drugstoreUF,
}: TrackSelectItemPayload): void {
  trackInteraction({
    page: interactionEventPages.dispensador_detalhes_receita,
    category: interactionEventCategory,
    action: interactionEventActions.select,
    label: interactionEventLabels.selecionar_item,
    properties: {
      prescription_id: String(prescriptionId),
      item_id: String(itemId),
      drugstore_id: drugstoreId,
      chain_id: chainId,
      can_dispense_partial: String(canDispensePartial),
      drugstore_name: String(drugstoreName),
      chain_name: String(chainName),
      drugstore_uf: String(drugstoreUF),
    },
  });
}
